import {UntilDestroy} from "@ngneat/until-destroy";
import {Component, Inject, OnInit} from "@angular/core";
import {WORKBENCH_VIEW_CONFIG, WorkbenchViewConfig} from '../../../shared/types';
import {ConsoleSessionId, DeviceId, ProjectId} from "@webmate-web-core/shared/types/ids";
import {BrowserSessionInfo} from "@webmate-web-core/shared/types/browsersession";
import {BrowserSessionService} from "@webmate-web-core/shared/services/browsersession.service";
import {Subject} from "rxjs";
import {WorkbenchViewComponent} from "../../../shared/components/viewcontainers/workbench-view.component";
import {WorkbenchLayoutManager} from "../../../shared/services/workbench-layout-manager.service";
import {WorkbenchContextService} from '../../../shared/services/workbench-context.service';

@UntilDestroy()
@Component({
    templateUrl: './expedition-automation.component.html',
    styleUrls: ['./expedition-automation.component.less'],
})
export class ExpeditionAutomationComponent extends WorkbenchViewComponent implements OnInit {

    projectId: ProjectId;

    activeExpedition?: BrowserSessionInfo;

    deviceId: DeviceId;
    consoleSessionId: ConsoleSessionId;

    wantRefresh: Subject<void> = new Subject<void>();
    stateIsLoading: boolean = false;

    interactionPath: string | undefined;


    constructor(@Inject(WORKBENCH_VIEW_CONFIG) public config: WorkbenchViewConfig<any>,
                private browserSessionService: BrowserSessionService,
                layoutManager:  WorkbenchLayoutManager,
                private workbenchContextService: WorkbenchContextService) {
        super(layoutManager, config);
    }

    ngOnInit() {
        const workbenchContext = this.workbenchContextService.getCurrentWorkbenchContext()!;
        this.projectId = workbenchContext.project;

        this.workbenchContextService.subscribeWorkbenchContext$().pipe(
        ).subscribe(_ => {
            this.activeExpedition = workbenchContext.expeditionContext.activeExpedition;
        });

        this.wantRefresh.next(undefined);
    }

    executeInteractionPath() {
        if (!this.activeExpedition || !this.activeExpedition.id) {
            console.error("No active browser session found to execute interaction path");
            return;
        }
        this.browserSessionService.executeInteractionPath$(this.activeExpedition.id, JSON.parse(this.interactionPath)).subscribe({
            next: (result) => {
                console.debug("Interaction path executed successfully", result);
            },
            error: (error) => {
                console.error("Error executing interaction path", error);
            }
        });

    }
}
